/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

//import {  Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IObrienSlideParallaxViewProps } from './obrien-slide-parallax';

import { useRef, useEffect } from "react";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default (props: IObrienSlideParallaxViewProps) => {

    let animateThis1 = useRef(null);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to( animateThis1, {
            scrollTrigger: {
                trigger: '.ob-slide', 
                start: "top 50px",
                scrub: 1,
            },
            duration: 2,
            x: '0',
            y: '160',
            ease: "linear",
        })
        
    }, [])


    const { obHeroImage, obHeroTitle, obHeroId, obHeroContent, obHeroImageOverlay, links1} = props;
    return (
        <>

            <div className={`ob-slide ${obHeroId}`}>

                <div className="text-container">
                    <div>
                        
                            <div>{obHeroTitle}</div>
                            <div dangerouslySetInnerHTML={{ __html: obHeroContent }}></div>
                            <div className="around-button">
                                {links1}
                            </div>
                        
                    </div>
                </div>
                
                <div className="hero-img-fix">
                    <div
                        ref={el => {
                        //@ts-ignore
                        animateThis1 = el}}
                    >
                        {obHeroImage}
                    </div>
                    <div className="overlay"></div>
                </div>

                <div className='heroImgOverlay'>{obHeroImageOverlay}</div>
                
            </div>

    
    </>
    );
};
